import { FormLongTextInput, FormSelectInput, FormTextInput } from '@superhi/design'
import { FieldConfig } from '@superhi/utils'
import { number, string } from 'yup'

import { PlanType } from './types'

const NAME: FieldConfig<typeof FormTextInput> = {
  label: 'Full name',
  ariaLabel: 'Full name',
  name: 'name',
  required: true,
  placeholder: 'E.g. Elaine Baines',
}

const COMPANY_NAME: FieldConfig<typeof FormTextInput> = {
  label: 'Company name',
  ariaLabel: 'Company name',
  name: 'companyName',
  required: true,
  placeholder: 'E.g. SuperHi',
}

const EMAIL: FieldConfig<typeof FormTextInput> = {
  label: 'Email',
  ariaLabel: 'Email',
  name: 'email',
  required: true,
  placeholder: 'E.g. elaine@superhi.com',
}

const SIZE: FieldConfig<typeof FormTextInput> = {
  label: 'Team size',
  ariaLabel: 'Team size',
  name: 'size',
  required: true,
  placeholder: 'E.g. 8',
  min: 2,
  type: 'number',
}

const PLAN: FieldConfig<typeof FormSelectInput> = {
  label: 'Plan type',
  ariaLabel: 'Plan type',
  name: 'plan',
  required: true,
  // placeholder: 'E.g. 8',
  options: [
    {
      display: 'Standard',
      value: 'standard',
    },
    {
      display: 'Enterprise',
      value: 'enterprise',
    },
  ],
}

const DETAILS: FieldConfig<typeof FormLongTextInput> = {
  label: "Any other details you'd like to share?",
  ariaLabel: "Any other details you'd like to share?",
  name: 'details',
  height: 6,
  required: false,
  placeholder:
    'What do you and/or your team want to get out of taking SuperHi courses? What skills are you hoping to explore with us?',
}

export const FIELDS = {
  NAME,
  COMPANY_NAME,
  EMAIL,
  SIZE,
  PLAN,
  DETAILS,
}

export const VALIDATION_SCHEMA = {
  name: string().required(),
  companyName: string().required(),
  email: string().required(),
  size: number().required(),
  plan: string<PlanType>().required(),
  details: string(),
}
